export default __webpack_public_path__ + "static/media/sip-logotype-l.8f3af1c9.svg";